import config from '@/config'
import axios from 'axios'
import { authHeader } from '@/helpers'
import { validateObject } from '@/helpers/acoData'
const { API_URL } = config

export const profileService = {
  getProfiles,
  addProfile,
  editProfile
}

async function getProfiles() {
  let url = `${config.API_URL}/api/user/profiles`
  let opts = { url, headers: authHeader() }
  let resp = await axios(opts)
  return resp.data
}

async function addProfile(eProfile) {
  let url = `${API_URL}/api/user/profiles/add`
  let opts = {
    url,
    data: {
      eProfile: eProfile
    },
    method: 'POST',
    headers: authHeader()
  }
  let res = await axios(opts)
  return res.data
}

async function editProfile(eProfile) {
  let url = `${API_URL}/api/user/profiles/edit`
  let opts = {
    url,
    data: {
      eProfile: eProfile
    },
    method: 'POST',
    headers: authHeader()
  }
  let res = await axios(opts)
  return res.data
}